import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getProductsListData } from "src/api/bi";
import { resetStore } from "src/store/actions";
import {
  ProductsInitialState,
  ProductsRequestParams
} from "src/config/tableInterface/interface";
import {
  handleFullfillForFetchProductData,
  handlePendingForFetchProductData,
  handleRejectForFetchProductData
} from "./utils";

const initialState: ProductsInitialState = {
  data: null,
  status: "idle",
  error: null,
  productsRequestId: undefined,
  countRequestId: undefined,
  vendorMap: {}
};

const viewProductsData = createSlice({
  name: "viewProductsData",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, () => initialState)
      .addCase(fetchProductsData.pending, handlePendingForFetchProductData)
      .addCase(fetchProductsData.fulfilled, handleFullfillForFetchProductData)
      .addCase(fetchProductsData.rejected, handleRejectForFetchProductData);
  }
});

export const fetchProductsData = createAsyncThunk(
  "viewItems/fetchProductsData",
  (payload: ProductsRequestParams) => getProductsListData(payload)
);

export default viewProductsData.reducer;
